import { gql } from '@apollo/client'

export const GET_USER_DATA = gql`
  query UserDataQuery($withClient: Boolean = true) {
    user {
      id
      name
      email
      timezone
      language
      role
      intercomHash
      onboarding {
        drive
        race
        explore
        maps
      }
      client @include(if: $withClient) {
        id
        logo_url
        contact {
          name
          email
          __typename
        }
        name
        country
        countryCode
        addons
        quota {
          limit
          reached
          displayDataConsumption
        }
        recoversInfo {
          hasPendingRecovers
        }
        __typename
        brands {
          id
          name
          slug
          headerLogoUrl
          logoUrl
          availableMonitors
          networks {
            fb {
              ex
              tk
              tk_error
              __typename
            }
            tw {
              id
              sn
              atk
              ats
              __typename
            }
            instagram {
              ex
              id
              sn
              p
              tk
              tk_error
              __typename
            }
            gmb {
              tk
              rtk
              ex
              __typename
            }
            yt {
              tk
            }
            tiktok {
              id
              tk
              sn
            }
            __typename
          }
          products {
            id
            slug
            languages
            countries
            name
            type
            exclusiveSources
            status
            narrativesEnabled
            webhook {
              v
              enabled
              internal
              __typename
            }
            biDockConfig {
              enabled
              url
              timezone
              exportEveryMinutes
              platforms
              credentials {
                database
                password
                schema
                username
                host
                port
                ssl
              }
            }
            feeds {
              id
              name
              slug
              type
              activeMonitors
              activeSources
              avatarUrl
              monitorEngine
              rules {
                klass
                src
              }
              featureFlags {
                followAlerts
              }
              profiles {
                facebook {
                  adAccounts {
                    id
                    name
                    updatedAt
                  }
                  pages {
                    name
                    pageId
                    updatedAt
                  }
                }
                instagram {
                  adAccounts {
                    name
                    updatedAt
                  }
                  pages {
                    id
                    updatedAt
                    webhooks
                    updatedAt
                  }
                }
                tiktok {
                  accounts {
                    id
                    name
                    updatedAt
                  }
                }
                linkedin {
                  accounts {
                    id
                    name
                    updatedAt
                  }
                  companies {
                    id
                    name
                    updatedAt
                  }
                }
                youtube {
                  channels {
                    id
                    name
                    updatedAt
                  }
                }
                gmb {
                  accounts {
                    id
                    name
                  }
                }
              }
              __typename
            }
            customRules {
              id
              name
              description
              conditions {
                type
                operation
                categories
              }
              results {
                type
                action
                sentiment
                categories
              }
            }
            brand {
              name
              logoUrl
            }
            __typename
          }
        }
      }
    }
  }
`

export const GET_RECOVER_DATA = gql`
  query GetRecoverData(
    $withClient: Boolean = true
    $brandId: ID!
    $productId: ID!
  ) {
    user {
      brand(id: $brandId) {
        id
        slug
        name
        logoUrl
        headerLogoUrl
        networks {
          fb {
            ex
            tk
            tk_error
            __typename
          }
          tw {
            id
            sn
            atk
            ats
            __typename
          }
          instagram {
            ex
            id
            sn
            p
            tk
            tk_error
            __typename
          }
          gmb {
            tk
            rtk
            ex
            __typename
          }
          yt {
            tk
          }
          tiktok {
            id
            tk
            sn
          }
          __typename
        }
        availableMonitors
      }
      product(id: $productId) {
        id
        type
        feeds {
          id
          name
          type
          activeMonitors
          activeSources
          monitorEngine
          rules {
            klass
            src
          }
          profiles {
            facebook {
              adAccounts {
                id
                name
                updatedAt
              }
              pages {
                name
                pageId
                updatedAt
              }
            }
            instagram {
              adAccounts {
                name
                updatedAt
              }
              pages {
                id
                updatedAt
                webhooks
                updatedAt
              }
            }
            tiktok {
              accounts {
                id
                name
                updatedAt
              }
            }
            linkedin {
              accounts {
                id
                name
                updatedAt
              }
              companies {
                id
                name
                updatedAt
              }
            }
            youtube {
              channels {
                id
                name
                updatedAt
              }
            }
            gmb {
              accounts {
                id
                name
              }
            }
          }
          __typename
        }
        __typename
      }
      client @include(if: $withClient) {
        quota {
          limit
          reached
        }
        recoversInfo {
          hasPendingRecovers
        }
      }
    }
  }
`
